/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AllergenRecipeModal_allAllergen$ref = any;
type DropdownCategories_allCategories$ref = any;
type IngredientRecipeModal_allIngredients$ref = any;
type IngredientRecipeModal_allUnitMeasure$ref = any;
type IngredientsSummaryList_summaryIngredient$ref = any;
type Recipe_recipe$ref = any;
type StepRecipeModal_allWarnings$ref = any;
type StepRecipeModal_configConstance$ref = any;
type StepRecipeModal_summaryIngredient$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SingleRecipePage_query$ref: FragmentReference;
declare export opaque type SingleRecipePage_query$fragmentType: SingleRecipePage_query$ref;
export type SingleRecipePage_query = {|
  +recipe: ?{|
    +name: string,
    +$fragmentRefs: Recipe_recipe$ref,
  |},
  +summaryIngredient: ?{|
    +$fragmentRefs: StepRecipeModal_summaryIngredient$ref & IngredientsSummaryList_summaryIngredient$ref
  |},
  +allRecipeIngredients: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +comments: ?string,
        +ingredient: {|
          +id: string,
          +name: string,
        |},
        +unityF: ?{|
          +id: string
        |},
        +qty: ?string,
        +section: ?{|
          +id: string,
          +name: ?string,
        |},
        +fraction: ?string,
      |}
    |}>
  |},
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
  +allWarnings: ?{|
    +$fragmentRefs: StepRecipeModal_allWarnings$ref
  |},
  +configConstance: ?{|
    +$fragmentRefs: StepRecipeModal_configConstance$ref
  |},
  +allIngredients: ?{|
    +$fragmentRefs: IngredientRecipeModal_allIngredients$ref
  |},
  +allUnitMeasure: ?{|
    +$fragmentRefs: IngredientRecipeModal_allUnitMeasure$ref
  |},
  +allAllergen: ?{|
    +$fragmentRefs: AllergenRecipeModal_allAllergen$ref
  |},
  +$refType: SingleRecipePage_query$ref,
|};
export type SingleRecipePage_query$data = SingleRecipePage_query;
export type SingleRecipePage_query$key = {
  +$data?: SingleRecipePage_query$data,
  +$fragmentRefs: SingleRecipePage_query$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "recipe",
  "variableName": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id",
      "type": "ID!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleRecipePage_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "RecipeNode",
      "kind": "LinkedField",
      "name": "recipe",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Recipe_recipe"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "summaryIngredient",
      "args": [
        {
          "kind": "Literal",
          "name": "ingredient",
          "value": "summary"
        },
        (v1/*: any*/)
      ],
      "concreteType": "RecipeIngredientNodeConnection",
      "kind": "LinkedField",
      "name": "allRecipeIngredients",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StepRecipeModal_summaryIngredient"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IngredientsSummaryList_summaryIngredient"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "id"
        },
        (v1/*: any*/)
      ],
      "concreteType": "RecipeIngredientNodeConnection",
      "kind": "LinkedField",
      "name": "allRecipeIngredients",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeIngredientNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecipeIngredientNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "comments",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IngredientNode",
                  "kind": "LinkedField",
                  "name": "ingredient",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnitMeasureNode",
                  "kind": "LinkedField",
                  "name": "unityF",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "qty",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecipeSectionNode",
                  "kind": "LinkedField",
                  "name": "section",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fraction",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeCategoryNodeConnection",
      "kind": "LinkedField",
      "name": "allCategories",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DropdownCategories_allCategories"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WarningNodeConnection",
      "kind": "LinkedField",
      "name": "allWarnings",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StepRecipeModal_allWarnings"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConfigConstance",
      "kind": "LinkedField",
      "name": "configConstance",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StepRecipeModal_configConstance"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IngredientNodeConnection",
      "kind": "LinkedField",
      "name": "allIngredients",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IngredientRecipeModal_allIngredients"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnitMeasureNodeConnection",
      "kind": "LinkedField",
      "name": "allUnitMeasure",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IngredientRecipeModal_allUnitMeasure"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AllergenNodeConnection",
      "kind": "LinkedField",
      "name": "allAllergen",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AllergenRecipeModal_allAllergen"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bf51aa0ccc5124c7a38a31be7e211a30';

module.exports = node;
